// src/pages/Contact.jsx

import React, {  useRef, useState   } from "react";
import { motion } from "framer-motion";
import MagicParticles from "../index/MagicParticles";
import Header from "../index/Header";
import Footer from "../index/Footer";
//import SimpleBar from 'simplebar-react';
//import 'simplebar-react/dist/simplebar.min.css';

export default function Contact() {
    const scrollRef = useRef();
    const [formData, setFormData] = useState({
      nombre: "",
      email: "",
      mensaje: "",
    });
    const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://eryndraeventos.es/api/contactanos", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setSuccess(true);
        setError(false);
        setFormData({ nombre: "", email: "", mensaje: "" });
      } else {
        throw new Error("Error en el envío");
      }
    } catch (err) {
      setSuccess(false);
      setError(true);
    }
  };
  return (
    //<SimpleBar ref={scrollRef} style={{ maxHeight: '100vh' }} autoHide={false}>
    <div className="relative font-cinzel text-eryndra-cream bg-eryndra-dream bg-cover bg-center min-h-screen overflow-hidden">


      <Header backgroundColor="bg-eryndra-forest/20" />

      <motion.section
        className="relative z-10 pt-24 pb-24 px-6 max-w-5xl mx-auto text-center"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h1 className="font-title text-4xl md:text-7xl  mb-4 text-eryndra-ivory uppercase mb-10 tracking-widest text-shadow-lg">
          Contáctanos
        </h1>
        <p className="font-bellefair text-2xl md:text-2xl mb-12">
          ¿Tienes una idea mágica? ¿Quieres organizar un evento inolvidable?
          <br/>Escríbenos y déjanos ayudarte a crear algo extraordinario.
        </p>

        <form onSubmit={handleSubmit} className="bg-eryndra-ivory/10  rounded-xl p-8 border border-eryndra-gold text-left space-y-6 shadow-xl">
          <div>
            <label className="block mb-2 uppercase text-sm font-semibold tracking-widest">Nombre</label>
            <input
               name="nombre"
               placeholder="Nombre"
               type="text"
               value={formData.nombre}
               onChange={handleChange}
               required
              className="w-full px-4 py-2 rounded-md bg-white text-eryndra-forest focus:outline-none focus:ring-2 focus:ring-eryndra-gold"
            />
          </div>

          <div>
            <label className="block mb-2 uppercase text-sm font-semibold tracking-widest">Correo electrónico</label>
            <input
            name="email"
            placeholder="Correo electrónico"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
              className="w-full px-4 py-2 rounded-md bg-white text-eryndra-forest focus:outline-none focus:ring-2 focus:ring-eryndra-gold"
            />
          </div>

          <div>
            <label className="block mb-2 uppercase text-sm font-semibold tracking-widest">Mensaje</label>
            <textarea
            name="mensaje"
            placeholder="Mensaje"
            rows={5}
            value={formData.mensaje}
            onChange={handleChange}
            required
              className="w-full px-4 py-2 rounded-md bg-white text-eryndra-forest focus:outline-none focus:ring-2 focus:ring-eryndra-gold"
            />
          </div>

          <button
            type="submit"
            className="btn-eryndra w-full sm:w-auto mx-auto block"
          >
            Enviar mensaje
          </button>
          {success && (
              <p className="text-green-500 mt-4 text-center">
                ¡Mensaje enviado correctamente!
              </p>
            )}
            {error && (
              <p className="text-red-500 mt-4 text-center">
                Hubo un error al enviar el mensaje.
              </p>
            )}
        </form>
      </motion.section>
      <Footer />
    </div>
    //</SimpleBar>
  );
}
